const API_URL = window.location.hostname === 'localhost'
    ? 'http://localhost:3001/api'
    : '/api';

// Kullanıcı bilgisini localStorage'dan al
const getUser = () => {
    const userData = localStorage.getItem('user');
    return userData ? JSON.parse(userData) : null;
};

// API isteği yap
const apiRequest = async (endpoint: string, options: RequestInit = {}) => {
    const user = getUser();

    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...(options.headers as Record<string, string> || {})
    };

    // User ID'yi header'a ekle (basit auth)
    if (user?.id) {
        headers['X-User-Id'] = user.id.toString();
    }

    const response = await fetch(`${API_URL}${endpoint}`, {
        ...options,
        headers
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.error || 'Bir hata oluştu');
    }

    return data;
};

// Auth API
export const authApi = {
    login: async (email: string, sifre: string) => {
        const data = await apiRequest('/auth/login', {
            method: 'POST',
            body: JSON.stringify({ email, sifre })
        });
        // Kullanıcıyı localStorage'a kaydet
        localStorage.setItem('user', JSON.stringify(data.user));
        return data;
    },
    logout: () => {
        localStorage.removeItem('user');
    },
    getMe: () => apiRequest('/auth/me'),
    getCurrentUser: getUser
};

// Users API
export const usersApi = {
    getAll: () => apiRequest('/users'),
    getById: (id: number) => apiRequest(`/users/${id}`),
    create: (userData: any) => apiRequest('/users', {
        method: 'POST',
        body: JSON.stringify(userData)
    }),
    update: (id: number, userData: any) => apiRequest(`/users/${id}`, {
        method: 'PUT',
        body: JSON.stringify(userData)
    }),
    delete: (id: number) => apiRequest(`/users/${id}`, { method: 'DELETE' })
};

// Ruhsatlar API
export const ruhsatlarApi = {
    getAll: () => apiRequest('/ruhsatlar'),
    getById: (id: number) => apiRequest(`/ruhsatlar/${id}`),
    create: async (formData: FormData) => {
        const user = getUser();
        const response = await fetch(`${API_URL}/ruhsatlar`, {
            method: 'POST',
            headers: user?.id ? { 'X-User-Id': user.id.toString() } : {},
            body: formData
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error);
        return data;
    },
    update: async (id: number, formData: FormData) => {
        const user = getUser();
        const response = await fetch(`${API_URL}/ruhsatlar/${id}`, {
            method: 'PUT',
            headers: user?.id ? { 'X-User-Id': user.id.toString() } : {},
            body: formData
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error);
        return data;
    },
    delete: (id: number) => apiRequest(`/ruhsatlar/${id}`, { method: 'DELETE' })
};

// Poliçeler API
export const policelerApi = {
    getAll: () => apiRequest('/policeler'),
    getById: (id: number) => apiRequest(`/policeler/${id}`),
    create: (policeData: any) => apiRequest('/policeler', {
        method: 'POST',
        body: JSON.stringify(policeData)
    }),
    update: (id: number, policeData: any) => apiRequest(`/policeler/${id}`, {
        method: 'PUT',
        body: JSON.stringify(policeData)
    }),
    delete: (id: number) => apiRequest(`/policeler/${id}`, { method: 'DELETE' }),
    getYaklasan: () => apiRequest('/policeler/yaklasan/bitecekler')
};

// Teklifler API
export const tekliflerApi = {
    // Public - auth gerektirmez
    create: async (teklifData: any) => {
        const response = await fetch(`${API_URL}/teklifler`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(teklifData)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error);
        return data;
    },
    // Admin
    getAll: () => apiRequest('/teklifler'),
    getById: (id: number) => apiRequest(`/teklifler/${id}`),
    update: (id: number, data: any) => apiRequest(`/teklifler/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data)
    }),
    delete: (id: number) => apiRequest(`/teklifler/${id}`, { method: 'DELETE' })
};

// Muayeneler API
export const muayenelerApi = {
    getAll: () => apiRequest('/muayeneler'),
    getYaklasan: () => apiRequest('/muayeneler/yaklasan'),
    create: (data: any) => apiRequest('/muayeneler', { method: 'POST', body: JSON.stringify(data) }),
    update: (id: number, data: any) => apiRequest(`/muayeneler/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id: number) => apiRequest(`/muayeneler/${id}`, { method: 'DELETE' })
};

// Belgeler API
export const belgelerApi = {
    getAll: (params?: string) => apiRequest(`/belgeler${params ? '?' + params : ''}`),
    create: async (formData: FormData) => {
        const user = getUser();
        const response = await fetch(`${API_URL}/belgeler`, {
            method: 'POST',
            headers: user?.id ? { 'X-User-Id': user.id.toString() } : {},
            body: formData
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error);
        return data;
    },
    delete: (id: number) => apiRequest(`/belgeler/${id}`, { method: 'DELETE' })
};

// İptaller API
export const iptallerApi = {
    getAll: () => apiRequest('/iptaller'),
    create: (data: any) => apiRequest('/iptaller', { method: 'POST', body: JSON.stringify(data) }),
    update: (id: number, data: any) => apiRequest(`/iptaller/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id: number) => apiRequest(`/iptaller/${id}`, { method: 'DELETE' })
};

// Admin Stats API
export const adminStatsApi = {
    get: () => apiRequest('/admin/stats')
};

export { getUser, API_URL };
